import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import LandingPage from "../../LandingPage";
import Loader from "../../components/Loader";
import HPOTree from "../../components/atoms/HPOTree";
import { getLoading } from "../../state/selectors/general.selectors";
import {
  renderSingleWithLabel,
  renderMultipleWithLabel,
  getVarsoUrl,
} from "../../common/helpers/helpers";
import HelperText from "../../components/atoms/HelperText";

// Page displayed in url: https://varsome.com/disease/30010000007433
class Disease extends LandingPage {
  render() {
    let tmpl;
    const { result, isLoading } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    if (this.state) {
      if (result) {
        const disease = result;
        const references = disease.referenced_by;
        const hpo = {
          hpo: [
            {
              source: "HPO",
              diseases: [
                {
                  disease_name: disease.disease_name,
                  mondo_id: disease.mondo_id,
                  expanded: true,
                  phenotypes: disease.phenotypes,
                },
              ],
            },
          ],
        };

        tmpl = (
          <div>
            <div className="varsome-result-fixed">
              <div className="varsome-container">
                <div className="varsome-title">
                  {"Disease "}
                  <HelperText fieldDescriptionKey="Disease" />
                </div>
                <div className="varsome-inner-container">
                  <div className="varsome-horiz-flex">
                    {renderSingleWithLabel(
                      disease,
                      "disease_name",
                      "Disease name"
                    )}
                    {renderMultipleWithLabel(
                      disease,
                      "Monarch Mondo MONDO.synonym",
                      "MonDO disease synonyms"
                    )}
                  </div>
                  <div className="varsome-horiz-list-label tw-text-center">
                    <a
                      href={getVarsoUrl(
                        "http://human-phenotype-ontology.github.io"
                      )}
                      target="_blank"
                    >
                      {"Human Phenotype Ontology "}
                    </a>
                    <HelperText fieldDescriptionKey="Human Phenotype Ontology" />
                  </div>
                  <HPOTree HPOTree={hpo} />
                </div>
              </div>
            </div>
            {this.renderReferences(references)}
          </div>
        );
      }
    }

    return tmpl || null;
  }
}

Disease.propTypes = {
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    loading: getLoading(state),
  };
};

export default connect(mapStateToProps, {})(Disease);
